export default __webpack_public_path__ + "static/media/img3.f37233e6.jpeg";